import {HFormStructure} from "../../ui/types";

export const modalStructure: HFormStructure = [
  ['mark', 'model'],
  ['color', 'number'],
  'capacity'
]
